import React, { Fragment } from 'react'
import { connect } from 'react-redux'
import { Form, Input, Select } from 'semantic-ui-react'
import { sortByAttr } from '../helpers/arrayHelpers'
import {
  CUSTOMER_PHONE,
  CUSTOMER_NAME,
  CUSTOMER_EMAIL,
  VEHICLE_VIN,
  AFFILIATION_IDS
} from '../constants/search_filters'

class CustomFilters extends React.Component {
  updateFilterStore = (data) => {
    this.props.dispatch({
      type: 'SHOP_ORDER_FILTERS_UPDATE',
      payload: data
    })
  }

  render() {
    const { affiliation_ids, vehicle_vin, customer_phone, customer_name, customer_email, affiliations } = this.props
    let affiliationOptions = sortByAttr(affiliations, 'name', 'asc').map(a => {
      return { text: a.name, key: `custom-filter-${a.name}-${a.id}`, value: a.id }
    })
    affiliationOptions.push({ text: '', key: `custom-filter-none`, value: [] })

    const fieldsData = [
      { value: vehicle_vin, name: VEHICLE_VIN, label: 'VIN:' },
      { value: customer_name, name: CUSTOMER_NAME, label: 'Customer Name:' },
      { value: customer_phone, name: CUSTOMER_PHONE, label: 'Customer Phone:' },
      { value: customer_email, name: CUSTOMER_EMAIL, label: 'Customer Email:' }
    ]

    return (
      <Fragment>
        {fieldsData.map(data => {
          return (
            <Form.Field key={`custom-filter-${data.name}`} style={{marginTop: "10px"}}>
              <label>{data.label}</label>
              <Input
                name={data.name}
                type="text"
                value={data.value}
                onChange={(e) => {
                  e.preventDefault()
                  this.updateFilterStore({ [data.name]: e.target.value })
                }}
              />
            </Form.Field>
          )
        })}
        <Form.Field key='custom-filter-affiliation_ids' style={{marginTop: "10px"}}>
          <label>Affiliation:</label>
          <Select
            multiple
            search
            onChange={(e, selection) => {
              e.preventDefault()
              this.updateFilterStore({ [AFFILIATION_IDS]: selection.value })
            }}
            value={affiliation_ids}
            options={affiliationOptions}
            style={{marginTop: '3px'}}
          />
        </Form.Field>
      </Fragment>
    )
  }
}

const mapStateToProps = (state) => {
  const filters = state.shopOrderFilters.currentFilters || {}
  const { customer_phone, customer_name, customer_email, vehicle_vin, affiliation_ids } = filters

  return {
    affiliations: state.affiliations.affiliations,
    customer_phone: customer_phone,
    customer_name: customer_name,
    customer_email: customer_email,
    vehicle_vin: vehicle_vin,
    affiliation_ids: affiliation_ids
  }
}

export default connect(mapStateToProps)(CustomFilters)
